import { HStack, StackProps, Text } from "@chakra-ui/react";
import { logEvent } from "helpers/analytics";
import React, { useCallback, useMemo } from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

interface CanadaOpportunityBannerProps extends StackProps {}

export const CanadaOpportunityBanner = ({
  ...stackProps
}: CanadaOpportunityBannerProps) => {
  const location = useLocation();

  const shouldDisplay = useMemo(() => {
    const hiddenPages = ["/work-abroad", "/passage", "/study-work-abroad"];

    return !hiddenPages.includes(location.pathname);
  }, [location.pathname]);

  if (!shouldDisplay) {
    return null;
  }

  return (
    <HStack
      py={{
        base: "16px",
        md: "20px",
      }}
      px={"20px"}
      backgroundColor="lavender.500"
      display="flex"
      justifyContent="center"
      {...stackProps}
    >
      <Text
        fontSize={{
          base: "13px",
          md: "20px",
        }}
        color="white"
        fontWeight="medium"
      >
        We&apos;ve launched educational loans and migration support to Canada
        for skilled workers.{" "}
        <Link
          to="/study-work-abroad"
          style={{ textDecoration: "underline" }}
          onClick={() => {
            logEvent("CanadaOpportunity_banner_link_clicked");
          }}
        >
          Learn More
        </Link>
      </Text>
    </HStack>
  );
};
